import config from '@/config';
import { IVuexRootState } from '@/types';
import axios, { AxiosRequestConfig, AxiosStatic, Method } from 'axios';

export default {
  /**
   * dependency injection, partial execution for Axios
   * includes auth header if user is logged in
   */
  api:
    (state: IVuexRootState) =>
    (axios_: AxiosStatic) =>
    (baseURL: string) =>
    (method: Method) =>
    (url: string, addlOptions: Object | null = null) => {
      let options: AxiosRequestConfig = { method, baseURL, url };
      if (state.token) options.headers = { Authorization: `Bearer ${state.token}` };
      if (addlOptions) options = { ...options, ...addlOptions };
      return axios_(options);
    },

  /**
   * partial function remaining parameters:    (url [, addlOptions])
   * url looks like '/fetch/sgfs'
   * addlOptions looks like { params: {limit: 5}}
   * addlOptions looks like { data: {limit: 5}}
   */
  apiGet: (_state: IVuexRootState, getters: any) => getters.api(axios)(config.apiUrl)('get'),

  apiPut: (_state: IVuexRootState, getters: any) => getters.api(axios)(config.apiUrl)('put'),

  /**
   * A PUT that still goes out while the tab is closing. sendBeacon can't send the auth header and axios 1.1 has no
   * keepalive, so this uses fetch. It resolves like axios, to { data }.
   */
  apiPutKeepalive: (state: Pick<IVuexRootState, 'token'>) => async (url: string, data: object) => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (state.token) headers.Authorization = `Bearer ${state.token}`;
    const response = await fetch(`${config.apiUrl}${url}`, {
      body: JSON.stringify(data),
      headers,
      keepalive: true,
      method: 'PUT',
    });
    if (!response.ok) throw new Error(`PUT ${url} failed with ${response.status}`);
    return { data: await response.json() };
  },

  apiPost: (_state: IVuexRootState, getters: any) => getters.api(axios)(config.apiUrl)('post'),

  apiDelete: (_state: IVuexRootState, getters: any) => getters.api(axios)(config.apiUrl)('delete'),

  // different baseURL for lecture audio, json and sgf files
  apiGetLectureComponent: (_state: IVuexRootState, getters: any) =>
    getters.api(axios)(config.lecturesUrl)('get'),

};
